import { MessagePathNode } from "@/shared/domain/topics";

import { cyclingColorScale } from "./CyclingColorScale";
import { PlotSeries } from "./schema";

// UX assumption: each panel we generate may use different colors for the same message paths.
// This cache is unique to each JS realm that generates colors, so multiple web workers
// may have different cached colors for different series.
// If we decide to change that assumption, this cache and all uses of `colorForSeries`
// should be moved to the React layer on the UI thread to establish a single source of truth,
// possibly as an inherited component for the plot panels.
const colorCache: Record<string, string> = {};

/**
 * Assigns a color for a series based on panel ID and series data.
 * Uses a cache to ensure consistent colors for the same topic/message path.
 */
export function assignSeriesColor(
  panelId: string,
  series: PlotSeries["data"],
): string {
  const messagePath = MessagePathNode.partsToString(series.messagePath.parts);
  const hash = `${panelId}:${series.topic.name}.${messagePath}`;

  // If the color is already in the cache, return it
  if (colorCache[hash]) {
    return colorCache[hash];
  }

  // Otherwise, get the next color for the panel
  const color = cyclingColorScale.getNextColorForPanel(panelId);
  colorCache[hash] = color;
  return color;
}
